"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundraiseOfferStatus = void 0;
var FundraiseOfferStatus;
(function (FundraiseOfferStatus) {
    FundraiseOfferStatus["PAID"] = "paid";
    FundraiseOfferStatus["UNPAID"] = "unpaid";
    FundraiseOfferStatus["CANCELLED"] = "cancelled";
})(FundraiseOfferStatus = exports.FundraiseOfferStatus || (exports.FundraiseOfferStatus = {}));
//# sourceMappingURL=IFundraiseOffer.js.map